<template>
    <transition name="fade">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <form class="modal-container">
                    <div class="modal-body">
                        <div class="background-image">
                            <!--<img
                            class="login-page__logo"
                            :srcset="
                                `${$store.state.appUrl}/img/pwa/app/payment.png, ${$store.state.appUrl}/img/pwa/app/payment@2x.png 2x`
                            "
                            :src="
                                `${$store.state.appUrl}/img/pwa/app/payment.png`
                            "
                            alt="Thrive"
                        />-->
                        
                        </div>
                        <div class="information"> 
                            <h2 class="popup_head text-primary text-center font-bold"> {{$t('oops')}} </h2>
                        <p> {{$t('popuptext')}}</p>
                       
                        </div>
                       
                    </div>
                    <div class="modal-footer">
                        <button
                        v-ripple
                        type="button"
                        class="btn-active btn-full popup-btn" 
                        @click="clickHandler"
                    >
                      <span class="popup-text block">{{
                        $t('connect')
                        }}</span>
                    </button>
                       </div>
                </form>
            </div>
        </div>
    </transition>
</template>

<script>
import Button from "../UI/Button";
import mixins from "../../config/mixins";
export default { 
    name: "PaymentModal",
    components: {
        Button
        
    },
    mixins: [mixins.npos, mixins.plaid],
    props: ["url", "title", "id"],

    data: function() {
        return {}
    },

    mounted() {
       // this.values.message = `${this.title} - ${this.url}`;
    },

    methods: {
        clickHandler: function() {
            this.recreate = 0;
            this.plaidLoad();
            console.log('after');
        }
       
    },
};
</script>
